import { useMemo } from 'react'

import { useParams } from 'react-router-dom'

type UseAutomationId = () => {
  isNewAutomation: boolean
  automationId: string | undefined
}

export const useAutomationId: UseAutomationId = () => {
  const { automationId } = useParams<{ automationId: string }>()

  const isNewAutomation = useMemo(() => {
    return automationId === 'new'
  }, [automationId])

  return { isNewAutomation, automationId }
}
